import myNetwork from '@/mycore/network/apimanagement';
import * as api from '../../../mycore/module/api';
import { SERVICE_PAGE_TYPE } from '@/configs/constants';
export function getOrderInfo(callback, ordercode) {
    api.getOrderInfo(callback, ordercode);
}
export function sendOTP(callback, orderId, paidType) {
    api.sendOTP(callback, orderId, paidType);
}
export function checkOTP(callback, orderId, code) {
    api.checkOTP(callback, orderId, code);
}
export function pushPotentialCustomer(callback, OrderId, PaidPaymentType) {
    api.pushPotentialCustomer(callback, OrderId, PaidPaymentType);
}
export function SearchOrder(callback, ordercode) {
    myNetwork
        .post('/api/saleplatform/order/search-order', {
            OrderCode: ordercode,
        })
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((err) => {
            callback(false, null, {
                message: error,
            });
        });
}

/**
 * API lay data bao cao phat trien thue bao
 * @param {*} callback
 */
export function reportPTTB(callback) {
    myNetwork
        .get('/posts')
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, {
                message: error,
            });
        });
}

export function updatePackageOrder(
    callback,
    ordercode,
    locationid,
    district,
    prepaidTime,
    listPackage,
    service_code = 'camera'
) {
    api.updatePackageOrder(callback, {
        service_code,
        ordercode,
        locationid,
        district,
        prepaidTime,
        listPackage,
    });
}
export function updateOrderDetail(callback, data) {
    api.updateOrderDetail(callback, data);
}

export function getPackagesFee(callback, service_code = 'camera', locationid) {
    api.getPackagesFee(callback, service_code, locationid);
}

export function checkPassport(callback, passport, type = 1, captcha) {
    api.checkPassport(callback, passport, 1, captcha); // camera module: type = 1
}

export function updateContractsRefferal(callback, ordercode, ContractRefInfo) {
    api.updateContractsRefferal(callback, ordercode, ContractRefInfo);
}

export function checkDate(callback, date, orderid) {
    api.checkDate(callback, date, orderid);
}

export function getCategoriesDisplayType(callback, locationId = 8, district = 'Q1', source = 1) {
    api.getCategoriesDisplayType(callback, '4', locationId, district, source); // type camera: 4
}

export function updateInfoCustomer(callback, ordercode, body) {
    api.updateInfoCustomer(callback, ordercode, 'camera', body);
}
export function getCategoryDetail(callback, { CategoryServices: CategoryServices, SysName: SysName }) {
    api.getCategoryDetail(callback, { CategoryServices: CategoryServices, SysName: SysName });
}

export function getSetting(callback, SaleTeamId, orderID, billType) {
    api.getSetting(callback, SaleTeamId, orderID, billType);
}

export function getCategories(callback) {
    let location = {
        locationid: '8',
        districtid: '1',
        wardid: '1',
    };
    const locationData = sessionStorage.getItem('dataLocation') || localStorage.getItem('dataLocation');
    if (locationData) {
        location = JSON.parse(locationData);
    }
    myNetwork
        .post('/api/saleplatform/catalog/get-categories', {
            SaleTeamId: parseInt(sessionStorage.SaleTeamId) || 29,
            CusTypeId: 102,
            CusTypeL2Id: 132,
            LocationId: parseInt(location.locationid || 8),
            DistrictId: parseInt(location.districtid || 1),
            WardId: parseInt(location.wardid || 1),
            PageType: SERVICE_PAGE_TYPE.SMART_HOME,
        })
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, {
                message: error,
            });
        });
}

export function getServiceFromName(callback, routerName) {
    api.getServiceFromName(callback, routerName);
}


export function getOrderDetail(callback, orderid) {
    api.getOrderDetail(callback, orderid);
}

export function getPaymentMethod(callback, orderid) {
    api.getPaymentMethod(callback, orderid);
}
export function createOrder(callback, data) {
    myNetwork
        .post('/api/saleplatform/order/smart-home/create-order', {...data })
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, {
                message: error,
            });
        });
}
